import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60644d26")

_pushScopeId("data-v-60644d26")
const _hoisted_1 = {
  key: 0,
  id: "perspective"
}
const _hoisted_2 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-rectangle-list fa-lg p-mr-1 scorecard-blue-icon" }, null, -1)
const _hoisted_4 = { class: "p-d-flex p-flex-row p-ai-center kn-flex" }
const _hoisted_5 = { class: "p-d-flex p-ai-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "p-d-flex p-flex-row p-ai-center scorecards-kpi-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_ScorecardsTableHint = _resolveComponent("ScorecardsTableHint")
  const _component_ScorecardsTargetItem = _resolveComponent("ScorecardsTargetItem")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.perspective)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "p-d-flex p-ai-center",
            style: _ctx.descriptor.style.inputContainer
          }, [
            (!_ctx.expanded)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "fas fa-chevron-right",
                  class: "p-button-text p-button-rounded p-button-plain",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = true))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  icon: "fas fa-chevron-down",
                  class: "p-button-text p-button-rounded p-button-plain",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expanded = false))
                })),
            _hoisted_3,
            _createVNode(_component_InputText, {
              class: "kn-material-input scorecards-target-perspective-input",
              modelValue: _ctx.perspective.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.perspective.name = $event)),
              maxLength: 40,
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue"])
          ], 4),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_SelectButton, {
              class: "p-mr-1",
              modelValue: _ctx.selectedCriteria,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedCriteria = $event)),
              options: _ctx.descriptor.criteriaOptions,
              onChange: _ctx.onCriteriaChange
            }, {
              option: _withId((slotProps) => [
                _withDirectives(_createVNode("span", {
                  "data-test": 'select-button-' + slotProps.option
                }, _toDisplayString(slotProps.option), 9, ["data-test"]), [
                  [_directive_tooltip, _ctx.getSelectedCriteriaTooltip(slotProps.option, _ctx.$t)]
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onChange"]),
            (_ctx.selectedCriteria !== 'M')
              ? (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: 0,
                  style: _ctx.descriptor.style.multiselect,
                  modelValue: _ctx.perspective.options.criterionPriority,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.perspective.options.criterionPriority = $event)),
                  options: _ctx.perspective.targets,
                  optionLabel: "name",
                  optionValue: "name",
                  onChange: _ctx.onCriterionPriortyChanged,
                  "data-test": "criteria-select-input"
                }, null, 8, ["style", "modelValue", "options", "onChange"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode(_component_Button, {
              icon: "fa-solid fa-square-plus",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.addTarget
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('managers.scorecards.addTarget'),
                void 0,
                { top: true }
              ]
            ]),
            _createVNode(_component_Button, {
              icon: "fas fa-trash-alt",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.deletePerspectiveConfirm
            }, null, 8, ["onClick"])
          ])
        ]),
        (_ctx.expanded)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              (_ctx.perspective.targets.length === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode(_component_ScorecardsTableHint, {
                      hint: 'managers.scorecards.addTargetHint',
                      "data-test": "no-targets-hint"
                    }, null, 8, ["hint"])
                  ]))
                : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.perspective.targets, (target, index) => {
                    return (_openBlock(), _createBlock(_component_ScorecardsTargetItem, {
                      key: index,
                      propTarget: target,
                      criterias: _ctx.criterias,
                      kpis: _ctx.kpis,
                      onDeleteTarget: _ctx.deleteTarget,
                      onOpenKpiDialog: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('openKpiDialog', $event))),
                      onTouched: _ctx.onTargetTouched
                    }, null, 8, ["propTarget", "criterias", "kpis", "onDeleteTarget", "onTouched"]))
                  }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})